import { defaultCategories, defaultFormOfOwnership } from '@/context/default';
import { ColumnEnum, Weights } from '@/enums';
import strings from '@/language/Swedish';
import { ColumnType } from '@/types/dataTypes';

const todaysDate = new Date();

const defaultAdsWeightParams = {
  ancillary_area_weight: Weights.medium,
  construction_year_weight: Weights.none,
  registered_date_weight: Weights.medium,
  distance_weight: Weights.medium,
  floor_weight: Weights.none,
  floors_weight: Weights.none,
  living_area_weight: Weights.medium,
  monthly_fee_weight: Weights.none,
  population_center_weight: Weights.none,
  rooms_weight: Weights.none,
};

const defaultAdsRefParams = {
  ancillary_area_reference: null,
  construction_year_reference: 1800,
  floor_reference: null,
  floors_reference: null,
  living_area_reference: 78,
  monthly_fee_reference: null,
  price_reference: null,
  registered_date_reference: null,
  rooms_reference: null,
};

const defaultAdsFilterParams = {
  ad_advertising_days_min: null,
  ad_advertising_days_max: null,
  construction_year_min: null,
  construction_year_max: null,
  home_type: null,
  ownership_type: null,
  price_min: null,
  price_max: null,
  rooms_min: null,
  rooms_max: null,
  living_area_min: null,
  living_area_max: null,
  error_code: false,
  owner_id: '',
  registered_date_min: null,
  registered_date_max: null,
  is_close_to_population_centre: true,
  is_new_construction: false,
  excluded_ad_ids: [],
  limit: 15,
};

const resetAdsFilterParams = {
  ad_advertising_days_min: 1,
  ad_advertising_days_max: 365,
  home_type: defaultCategories,
  ownership_type: defaultFormOfOwnership,
  living_area_min: 0,
  living_area_max: 500,
  price_min: 0,
  price_max: 40,
  construction_year_min: 1850,
  construction_year_max: todaysDate.getFullYear(),
  rooms_min: 0,
  rooms_max: 10,
  error_code: false,
  owner_id: '',
  registered_date_min: null,
  registered_date_max: null,
  is_close_to_population_centre: true,
  is_new_construction: false,
  excluded_ad_ids: [],
  limit: 15,
};

const defaultAdsTableColumns: ColumnType[] = [
  {
    id: ColumnEnum.street,
    label: strings.table.columns.street,
    isVisible: true,
  },
  {
    id: ColumnEnum.registeredDate,
    label: strings.table.columns.registeredDate,
    isVisible: true,
  },
  {
    id: ColumnEnum.advertisingDays,
    label: strings.table.columns.advertisingDays,
    isVisible: true,
  },

  {
    id: ColumnEnum.constructionYear,
    label: strings.table.columns.constructionYear,
    isVisible: true,
  },
  {
    id: ColumnEnum.livingArea,
    label: strings.table.columns.livingArea,
    isVisible: true,
  },
  { id: ColumnEnum.rooms, label: strings.table.columns.rooms, isVisible: true },
  {
    id: ColumnEnum.floorFloors,
    label: strings.table.columns.floorFloors,
    isVisible: true,
  },

  {
    id: ColumnEnum.plotArea,
    label: strings.table.columns.plotArea,
    isVisible: true,
  },

  {
    id: ColumnEnum.ancillaryArea,
    label: strings.table.columns.ancillaryArea,
    isVisible: true,
  },

  { id: ColumnEnum.price, label: strings.table.columns.price, isVisible: true },
  {
    id: ColumnEnum.priceSqm,
    label: strings.table.columns.adPriceSqm,
    isVisible: true,
  },
  {
    id: ColumnEnum.monthlyFee,
    label: strings.table.columns.monthlyFee,
    isVisible: true,
  },
  {
    id: ColumnEnum.homeType,
    label: strings.table.columns.homeType,
    isVisible: true,
  },
  {
    id: ColumnEnum.ownershipType,
    label: strings.table.columns.ownershipType,
    isVisible: true,
  },

  { id: ColumnEnum.firm, label: strings.table.columns.firm, isVisible: true },

  { id: ColumnEnum.pdf, label: strings.table.columns.pdf, isVisible: true },
];

const defaultAdsTableColumnsExcel: ColumnType[] = [
  {
    id: ColumnEnum.street,
    label: strings.table.columns.street,
    isVisible: true,
  },
  {
    id: ColumnEnum.registeredDate,
    label: strings.table.columns.registeredDate,
    isVisible: true,
  },
  {
    id: ColumnEnum.advertisingDays,
    label: strings.table.columns.advertisingDays,
    isVisible: true,
  },

  {
    id: ColumnEnum.constructionYear,
    label: strings.table.columns.constructionYear,
    isVisible: true,
  },
  {
    id: ColumnEnum.livingArea,
    label: strings.table.columns.livingArea,
    isVisible: true,
  },
  { id: ColumnEnum.rooms, label: strings.table.columns.rooms, isVisible: true },
  {
    id: ColumnEnum.floor,
    label: strings.table.columns.floor,
    isVisible: true,
  },
  {
    id: ColumnEnum.floors,
    label: strings.table.columns.floors,
    isVisible: true,
  },
  {
    id: ColumnEnum.plotArea,
    label: strings.table.columns.plotArea,
    isVisible: true,
  },

  {
    id: ColumnEnum.ancillaryArea,
    label: strings.table.columns.ancillaryArea,
    isVisible: true,
  },

  { id: ColumnEnum.price, label: strings.table.columns.price, isVisible: true },
  {
    id: ColumnEnum.priceSqm,
    label: strings.table.columns.adPriceSqm,
    isVisible: true,
  },
  {
    id: ColumnEnum.monthlyFee,
    label: strings.table.columns.monthlyFee,
    isVisible: true,
  },
  {
    id: ColumnEnum.homeType,
    label: strings.table.columns.homeType,
    isVisible: true,
  },
  {
    id: ColumnEnum.ownershipType,
    label: strings.table.columns.ownershipType,
    isVisible: true,
  },

  { id: ColumnEnum.firm, label: strings.table.columns.firm, isVisible: true },

  { id: ColumnEnum.pdf, label: strings.table.columns.pdf, isVisible: true },
];

export {
  defaultAdsTableColumns,
  defaultAdsTableColumnsExcel,
  defaultAdsWeightParams,
  defaultAdsFilterParams,
  defaultAdsRefParams,
  resetAdsFilterParams,
};
